import { useState } from "react";
import postData from "../../utils/postData";
import "./style.scss";

const OptInForm = ({ prefix, nonce, ajax_url, basename, admin_url, info }) => {
  const [showPermission, setShowPermission] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const information = JSON.parse(info);

  const handleAgree = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    await postData("https://api.bplugins.com/wp-json/data/v1/accept-data", { ...information, status: "activate", marketing_allowed: true });

    await postData(`${ajax_url}?action=${prefix}-opt-in-update`, {
      nonce,
      actionType: "agree",
    });
    setIsLoading(false);
    window.location.href = `${admin_url}/plugins.php`;
  };

  const handleSkip = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    await postData(`${ajax_url}?action=${prefix}-opt-in-update`, {
      nonce,
      actionType: "skip",
    });

    setIsLoading(false);
    window.location.href = `${admin_url}/plugins.php`;
  };

  return (
    <>
      <div className="bts-opt-in">
        <div className="content">
          <div className="bp-connect">
            <span className="wp-icon">
              <i className="dashicons dashicons-wordpress"></i>
            </span>
            <i className="dashicons dashicons-plus fs-second"></i>
            <img src={`https://ps.w.org/${basename}/assets/icon-128x128.png`} alt="" />
            <i className="dashicons dashicons-plus fs-second"></i>
            <img src="https://bplugins.com/wp-content/uploads/2021/07/bplugins-white.png" alt="" />
          </div>
          <p>
            Hey <b>{information.user_display_name}</b>,<br /> Never miss an important update - opt in to our security and feature updates notifications, and non-sensitive diagnostic tracking with bplugins.com.
          </p>
        </div>
        <div className="actions">
          <form method="POST" action="<?php echo $this->url ?>">
            <button className="button button-primary" onClick={handleAgree} disabled={isLoading}>
              Agree & continue
            </button>
          </form>
          <button className="button button-secondary" onClick={handleSkip}>
            Skip
          </button>
        </div>
        <div className="what-is-granted">
          <p className="details-btn" onClick={() => setShowPermission(!showPermission)}>
            What permissions are being granted?
          </p>
          {showPermission && (
            <div className="permissions">
              <div className="permission">
                <i className="dashicons dashicons-admin-users"></i>
                <div>
                  <h3>YOUR PROFILE OVERVIEW</h3>
                  <p>Name and email address</p>
                </div>
              </div>
              <div className="permission">
                <i className="dashicons dashicons-admin-settings"></i>
                <div>
                  <h3>YOUR SITE OVERVIEW</h3>
                  <p>Site URL, WP version, PHP info</p>
                </div>
              </div>
              <div className="permission">
                <i className="dashicons dashicons-testimonial"></i>
                <div>
                  <h3>ADMIN NOTICES</h3>
                  <p>Updates, announcements, marketing, no spam</p>
                </div>
              </div>
              <div className="permission">
                <i className="dashicons dashicons-admin-plugins"></i>
                <div>
                  <h3>CURRENT PLUGIN STATUS</h3>
                  <p>Active, deactivated, or uninstalled</p>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="privacy-policy">
          <a href="https://bplugins.com/privacy-policy/" rel="noreferrer" target="_blank">
            Privacy Policy
          </a>
          <span>-</span>
          <a href="https://bplugins.com/terms-of-service/" rel="noreferrer" target="_blank">
            Terms and Condition
          </a>
        </div>
      </div>
    </>
  );
};

export default OptInForm;
